var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckBulletFill(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_35330",
    "data-name": "Group 35330",
    transform: "translate(-702.831 -3690.77)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_529",
    "data-name": "Ellipse 529",
    cx: 23,
    cy: 23,
    r: 23,
    transform: "translate(702.831 3690.77)",
    fill: "#1c9d87"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-ios-checkmark",
    "data-name": "Icon ionic-ios-checkmark",
    d: "M30.329,14l-1.635-1.681a.351.351,0,0,0-.26-.111h0a.337.337,0,0,0-.26.111L16.843,23.732l-4.124-4.124a.359.359,0,0,0-.52,0l-1.653,1.653a.37.37,0,0,0,0,.529l5.2,5.2a1.645,1.645,0,0,0,1.087.529,1.724,1.724,0,0,0,1.077-.511h.009L30.338,14.528A.4.4,0,0,0,30.329,14Z",
    transform: "translate(705.396 3693.963)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckBulletFill);
export default __webpack_public_path__ + "static/media/check-bullet-fill.051699c8369c7f5359c6c0443963c771.svg";
export { ForwardRef as ReactComponent };